<template>
  <v-data-table
    :headers="headers"
    :items="users"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-spacer></v-spacer>

        <v-dialog
          v-model="dialogCreate"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              新增使用者
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">新增使用者</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form">
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="createdItem.name"
                        label="Name"
                        :counter="15"
                        :rules="[rules.required, rules.max]"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="createdItem.account"
                        label="Account"
                        :counter="15"
                        :rules="[rules.required, rules.max]"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="createdItem.password"
                        label="Password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="showPassword ? 'text' : 'password'"
                        hint="At least 8 characters"
                        class="input-group--focused"
                        @click:append="showPassword = !showPassword"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-select
                        v-model="createdItem.role"
                        :items="roles"
                        :rules="[rules.required]"
                        required
                        label="Role"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeCreate"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="saveCreate"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogModify"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">修改使用者</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form">
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="motifiedItem.name"
                        label="Name"
                        :counter="15"
                        :rules="[rules.max, rules.required]"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="motifiedItem.account"
                        label="Account"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="motifiedItem.password"
                        label="Password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.min]"
                        :type="showPassword ? 'text' : 'password'"
                        hint="At least 8 characters"
                        class="input-group--focused"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-select
                        v-model="motifiedItem.role"
                        :items="roles"
                        label="Role"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeModify"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="saveMotify"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">您確定要刪除使用者 "{{ deletedItem.name }}" ?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        v-if="item.role !== '管理員'"
        small
        class="mr-2"
        @click="modifyItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        v-if="item.role !== '管理員'"
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="loadUsers"
      >
        Reload
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data: () => ({
      users: [],
      rules: {
        required: value => !!value || 'Required.',
        min: v => !v || v.length >= 8 || 'Min 8 characters',
        max: v => v.length <= 15 || 'Max 15 characters',
      },
      showPassword: false,
      dialogCreate: false,
      dialogModify: false,
      dialogDelete: false,
      roles: [
        "巡場員", "中控員", "遊客",
      ],
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
        { text: 'Account', value: 'account' },
        { text: 'Role', value: 'role' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      createdItem: {
        id: null,
        name: '',
        account: '',
        password: '',
        role: '',
      },
      motifiedItem: {
        id: null,
        name: '',
        account: '',
        password: '',
        role: '',
      },
      deletedItem: {
        id: null,
        name: '',
      },
      createdDefaultItem: {
        id: null,
        name: '',
        account: '',
        password: '',
        role: '',
      },
      motifiedDefaultItem: {
        id: null,
        name: '',
        password: '',
        account: '',
        role: '',
      },
      deletedDefaultItem: {
        id: null,
        name: '',
      },
    }),

    computed: {
    },

    watch: {
      dialogModify(val) {
        val || this.closeModify()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.loadUsers()
    },

    methods: {
      loadUsers() {
        this.axios.get('api/users').then((resp) => {
          this.users = [];
          resp.data.forEach(user => {
            this.users.push({
              id: user.id,
              name: user.name,
              account: user.account,
              role: user.role,
              createdAt: this.$moment(user.created_at).format('YYYY-MM-DD HH:mm:ss'),
            })
          })
        })
      },

      modifyItem (item) {
        this.motifiedItem = Object.assign({}, item)
        this.dialogModify = true
      },

      deleteItem (item) {
        this.deletedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.axios.delete(`api/user/${this.deletedItem.id}`).then(() => {
          this.loadUsers()
          this.closeDelete()
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeCreate() {
        this.dialogCreate = false
        this.$nextTick(() => {
          this.createdItem = Object.assign({}, this.createdDefaultItem)
          this.$refs.form.resetValidation()
        })
      },

      closeModify() {
        this.dialogModify = false
        this.$nextTick(() => {
          this.motifiedItem = Object.assign({}, this.motifiedDefaultItem)
          this.$refs.form.resetValidation()
        })
      },

      saveCreate() {
        if (this.$refs.form.validate()) {
          this.axios.post('api/user', {
            name: this.createdItem.name,
            account: this.createdItem.account,
            password: this.createdItem.password,
            role: this.createdItem.role,
          }).then(() => {
            this.loadUsers()
            this.closeCreate()
          })
        }
      },

      saveMotify() {
        if (this.$refs.form.validate()) {
          this.axios.patch(`api/user/${this.motifiedItem.id}`, {
            name: this.motifiedItem.name,
            password: this.motifiedItem.password,
            role: this.motifiedItem.role,
          }).then(() => {
            this.loadUsers()
            this.closeModify()
          })
        }
      }
    },
}
</script>
